import { useEffect, useRef, useState } from "react";
import { HttpTransportType, HubConnection } from "@microsoft/signalr";
import { SetUpSignalRConnection } from "./SignalRConnection";

export const useOwnerCodeChangeListener = (accessToken: string): { isConnected: boolean } => {
  const [isConnected, setIsConnected] = useState<boolean>(false);
  const connectionRef = useRef<HubConnection | null>(null);

  useEffect(() => {
    if (!accessToken) return;

    let isMounted = true;

    SetUpSignalRConnection("hub/eventhub", HttpTransportType.WebSockets, accessToken).then(connection => {
      if (!isMounted) {
        connection.stop();
        return;
      }
      connectionRef.current = connection;
      setIsConnected(true);

      connection.on("OwnerCodeChanged", () => {
        window.location.reload();
      });

      connection.onclose(() => {
        setIsConnected(false);
      });
    });

    return () => {
      isMounted = false;
      connectionRef.current?.stop();
      connectionRef.current = null;
      setIsConnected(false);
    };
  }, [accessToken]);

  return { isConnected };
};
